<template>
  <div class="p-b-25">
    <a-form ref='form' :model='search' class="m-b-25" :initialValues="search" :onFinish='pageSearchChange'
      layout='inline'>
      <a-form-item>
        <a-radio-group button-style="solid" @change="onChangeRadio" v-model:value="search.day_type">
          <a-radio-button :value="1">7天</a-radio-button>
          <a-radio-button :value="2">30天</a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="">
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
        <span class="s_c999">（地图颜色越深，代表该地区经销商数量越多）</span>
      </a-form-item>
    </a-form>
    <a-button type="primary" @click='back' v-if='level !== 0'>返回上一级</a-button>
    <a-spin :spinning="listLoading">
      <div class="m-b-25" ref="charts" style="width:100%;height:700px"></div>
    </a-spin>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'
      v-if='data.length'>
      <template v-slot:action="{ record }">
        <a @click='lookMore(record)' href="javascript:;" v-if="record.is_show_next">查看区域详情</a>
      </template>
    </a-table>
  </div>
</template>

<script>
  import echarts from 'echarts';
  import { reactive, toRefs, onMounted, ref } from 'vue';
  import { getJson } from "@/api/public";
  import { getOrderGeneral } from "@/api/order";
  import { iscode } from "@/utils/app";
  import { message } from "ant-design-vue";
  import { useChinaMap } from "./orderChinaMap.js";
  export default {
    props: {},
    setup(props) {
      let data = ref([]);
      const search = ref({
        start_time: "",
        end_time: "",
        day_type: 1,
        city_id: '',
        province_id: '',
        type: 2
      });
      const state = reactive({
        listLoading: false,
        total: 1,
        time: [],
        level: 0
      });
      let columns = [
        {
          title: "省份",
          dataIndex: "name",
          key: "name",
        },
        {
          title: '经销商数量',
          dataIndex: "count",
          key: "count",
        },
        {
          title: '经销商成交订单数',
          dataIndex: "dealer_pay_count",
          key: "dealer_pay_count",
        },
        {
          title: "经销商成交金额",
          dataIndex: "dealer_price_count",
          key: "dealer_price_count",
        },
        {
          title: "总部成交订单数",
          dataIndex: "general_pay_count",
          key: "general_pay_count",
        },
        {
          title: "总部成交金额",
          dataIndex: "general_price_count",
          key: "general_price_count",
        }
      ];
      // 页面筛选项搜索
      const pageSearchChange = async () => {
        initData(search.value);
      };
      // 7天/30天筛选
      const onChangeRadio = () => {
        search.value.start_time = "";
        search.value.end_time = "";
        state.time = [];
      };
      //日期筛选
      const onChange = (e) => {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
        search.value.day_type = e.length ? 0 : 1
      };
      const mapStack = ref([{ id: "100000", name: "china" }]);
      // 地图 echartData
      const charts = ref(null);
      const { setMap, initMap  } = useChinaMap();
      const handleMap = (data) => {
        setMap(mapStack.value[mapStack.value.length - 1], data);
      };
      const initData = async () => {
        state.listLoading = true
        let result = await getOrderGeneral({ ...search.value }).then((res) => res.data).catch((error) => error);
        result.data.forEach((element) => {
          if (element.name.indexOf("省") !== -1) {
            element.name = element.name.split("省").join("");
          }
        })
        data.value = result.data;
        if (result.data[0].is_show_next==1) {
          if (columns[columns.length - 1].title != '操作') {
            columns.push({
              title: "操作",
              key: "action",
              slots: { customRender: "action" },
            });
          }
        } else {
          columns.pop();
        }
        handleMap(data.value);
        state.listLoading = false
      };
      // 查看详情
      const lookMore = (e) => {
        state.level++;
        mapStack.value.push(e);
        if (state.level == 1) {
          search.value.province_id = e.id;
          search.value.city_id = "";
          initData();
        }
        if (state.level == 2) {
          search.value.province_id = "";
          search.value.city_id = e.id;
          initData();
        }
      };
      const back = () => {
        var map = mapStack.value.pop()
        if (state.level == 1) {
          state.level = 0;
          search.value.province_id = "";
          search.value.city_id = "";
          initData();
        }
        if (state.level == 2) {
          state.level = 1;
          search.value.province_id = mapStack.value[mapStack.value.length - 1].id;
          search.value.city_id = "";
          initData();
        }
      };
      onMounted(() => {
        initData();
        initMap(charts.value);
      });
      return {
        charts,
        search,
        ...toRefs(state),
        data,
        columns,
        onChange,
        onChangeRadio,
        back,
        lookMore,
        pageSearchChange
      };
    },
  };
</script>